import {
  ONBOARD_OTP_DATA,
  LOGIN_OBOARD,
  ONBOARD_DETAILS,
  ONBOARD_DOC_DETAILS,
} from "../actiontypes/NumBikeActiontypes";
//import { REGISTER } from "redux-persist/lib/constants";
// dispatch({ type: REGISTER, payload: data });

export function OnBoardDta(data) {
  return {
    type: ONBOARD_OTP_DATA,
    payload: data,
  };
}
export function ONBLogin(data) {
  return {
    type: LOGIN_OBOARD,
    payload: data,
  };
}
export function ONBDetils(data) {
  return {
    type: ONBOARD_DETAILS,
    payload: data,
  };
}
export function ONBDocDetails(data) {
  return {
    type: ONBOARD_DOC_DETAILS,
    payload: data,
  };
}
